var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.71 125.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-rw,.cls-2-rw{fill:none;stroke-miterlimit:10;stroke-width:2px;}\n.cls-1-rw{stroke:#ff3b83;}.cls-2-rw{stroke:#ffc300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone_Resume_new",
    "data-name": "Icone Resume new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-rw",
    d: "M83,87.77a13.73,13.73,0,0,0-13.7-12.9H53.53A30.24,30.24,0,0,1,23.29,44.63V33.55A32.55,32.55,0,0,1,55.84,1h3.35A21.12,21.12,0,0,1,80.31,22.12V43.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-rw",
    d: "M14.66,103h98.39a10.83,10.83,0,0,1,10.83,10.83h0a10.83,10.83,0,0,1-10.83,10.83H95.78A12.78,12.78,0,0,1,83,111.89V97.21"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2-rw",
    points: "77.65 34.42 80.29 34.42 80.29 26.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-rw",
    d: "M75.05,42.71h5.24V34.42H75.05a4.15,4.15,0,0,0-4.15,4.15h0A4.14,4.14,0,0,0,75.05,42.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-rw",
    d: "M83,88.6A13.72,13.72,0,0,1,96.71,74.88h15.76a30.24,30.24,0,0,0,30.24-30.24V33.55A32.55,32.55,0,0,0,110.16,1h-3.35A21.12,21.12,0,0,0,85.69,22.12V43.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-rw",
    d: "M91,42.71H85.71V34.42H91a4.15,4.15,0,0,1,4.15,4.15h0A4.14,4.14,0,0,1,91,42.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-rw",
    x: 6.15,
    y: 100.88,
    width: 8.51,
    height: 4.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-rw",
    x1: 3.72,
    y1: 103.06,
    y2: 103.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2-rw",
    x: 81.02,
    y: 88.1,
    width: 3.94,
    height: 9.28
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2-rw",
    points: "85.71 26.03 85.71 34.42 88.34 34.42"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeRewards);
export default __webpack_public_path__ + "static/media/home-rewards.6820483a056c2b3511b8f2739316ec6d.svg";
export { ForwardRef as ReactComponent };